module.exports = "/images/icon_exit_white.svg?75010449a93174c42500bbe6da356287";